/* eslint-disable no-param-reassign */
import { FormProvider } from 'react-hook-form';
import { CardRegistrationPaymentCardJsonldPaymentPaymentCardRead } from '@/api/generated';
import Checkbox from '@/atoms/forms/checkbox';
import TextInput from '@/atoms/forms/Input';
import Fieldset from '@/molecules/Fieldset';
import { ORIENTATION } from 'types/utils';
import ModalClassicLayout from '../../../layout/Classic';
import useCreatePaymentMethod from './hooks';
import { formatCardNumber, formatExpiryDate } from 'utils/paymentCards';

const PaymentCardCreateModal = ({
  closeModal,
  onChange,
  forcePersist,
}: {
  closeModal: () => void;
  onChange?: (data: CardRegistrationPaymentCardJsonldPaymentPaymentCardRead) => void;
  forcePersist?: boolean;
}) => {
  const { formMethods, onSubmit } = useCreatePaymentMethod({ onChange, forcePersist });

  return (
    <ModalClassicLayout
      closeModal={closeModal}
      isSubmitDisabled={formMethods.formState.isSubmitting}
      onSubmit={onSubmit}
      title="your-payout-method"
    >
      <FormProvider {...formMethods}>
        <form className="flex flex-col gap-4 pb-4" onSubmit={onSubmit}>
          <TextInput
            icon="fa-credit-card"
            label="card-number"
            maxLength={19}
            name="cardNumber"
            placeholder="card-number"
            transform={{
              output: formatCardNumber,
            }}
            type="text"
          />
          <Fieldset orientation={ORIENTATION.HORIZONTAL}>
            <TextInput
              label="expirationDate"
              name="cardExpirationDate"
              placeholder="MM/YY"
              transform={{
                output: formatExpiryDate,
              }}
              type="text"
            />
            <TextInput label="cvv" maxLength={4} name="cardCvx" placeholder="cvv" type="text" />
          </Fieldset>
          <Checkbox disabled={forcePersist} label="record-payout-method" name="persist" />
          <input className="hidden" type="submit" />
        </form>
      </FormProvider>
    </ModalClassicLayout>
  );
};

export default PaymentCardCreateModal;
